import {useEffect, useState} from 'react'
import {subscribe, unsubscribe} from '@/script/event.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()

    const isImportant = node => {
        const {bizNodeType, ruleStar} = node.data

        return (
            '1' === ruleStar &&
            'BDLOGIC' === bizNodeType
        )
    }

    const [nodes, setNodes] = useState(() => {
        const iter = function* () {
            for (const node of map.dfs(map.root)) {
                if (isImportant(node)) {
                    yield node
                }
            }
        }

        return new Set(iter())
    })

    useEffect(
        () => {
            const handleModelChange = changes => {
                const newNodes = new Set(nodes)

                for (const [node, change] of changes) {
                    if (nodes.has(node)) {
                        if (
                            ! isImportant(node) ||
                            change.has('isDeleted')
                        ) {
                            newNodes.delete(node)
                        }
                    }
                    else {
                        if (isImportant(node)) {
                            newNodes.add(node)
                        }
                    }
                }

                setNodes(newNodes)
            }

            subscribe(map, 'model_change', handleModelChange)

            return () => {
                unsubscribe(map, 'model_change', handleModelChange)
            }
        },

        []
    )

    return nodes
}
